import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/file_templates/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/settings/file_templates';

const Home: NextPage = () => (
  <>
    <NskHead title="帳票設定" />
    <Component />
  </>
);

export default Home;
